export const MAP = {
  Winter: 'icon-winter',
  Street: 'icon-street',
  'All-Season': 'icon-all-season',
  'All-Terrain': 'icon-terrain'
}
